<template>
  <c-row>
    <loader v-show="loading" />
    <c-col col="5">
      <c-card>
        <c-card-header>
          <c-card-title>
            <strong>Faktur Po</strong>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <p>
            Barang yang datang harus di sesuaikan deftar berikut
            <strong>#{{ data.faktur }}</strong> Dari Supplier
            <strong v-if="data.supplier">{{ data.supplier.perusahaan }}</strong>
          </p>
          <div class="table-print">
            <table border="1" class="bordered" style="width: 100%">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Kode Barang</th>
                  <th>Nama Barang</th>
                  <th>Qty</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, k) in data.purchase_details" :key="k">
                  <td align="center">{{ k + 1 }}</td>
                  <td>{{ d.item.code }}</td>
                  <td>{{ d.item.name }}</td>
                  <td align="center">{{ d.qty_po }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-card-body>
      </c-card>
    </c-col>
    <c-col col="7">
      <c-card>
        <c-card-header>
          <strong>Approval</strong>
          <div class="card-header-actions">
            <a
              class="btn btn-outline-success over-block"
              @click="goBack"
              v-c-tooltip.click="'Back'"
              ><i class="cil-arrow-circle-left"></i
            ></a>
            <i-button
              icon="cil-print"
              tooltip="Print"
              class="over-block"
              @action="doPrint(data.id)"
            />
          </div>
        </c-card-header>
        <c-card-body>
          <div>
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Kode Barang</th>
                  <th>Nama Barang</th>
                  <th width="60">Qty</th>
                  <th width="90">Harga</th>
                  <th width="100">Sub Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, k) in data.purchase_details" :key="k">
                  <td>{{ k + 1 }}</td>
                  <td>{{ d.item.code }}</td>
                  <td>{{ d.item.name }}</td>
                  <td>
                    <button-edit-input
                      v-model="d.qty_real"
                      :index="k"
                      @change="calculateSub(d)"
                    />
                  </td>
                  <td>
                    <button-edit-input
                      v-model="d.hpp"
                      :index="k"
                      @change="calculateSub(d)"
                    />
                  </td>
                  <td align="right" class="unicode">
                    {{ d.sub_total | thousandSeparator }}
                  </td>
                </tr>
                <tr>
                  <td colspan="5">Total</td>
                  <td align="right" class="unicode">
                    {{ data.total | thousandSeparator }}
                  </td>
                </tr>
              </tbody>
            </table>
            <c-row style="padding: 10px">
              <c-col col="6">
                <div class="form-group">
                  <label>Total (Rp)</label>
                  <span type="text" class="form-control right">{{
                    data.total | thousandSeparator
                  }}</span>
                </div>
                <div class="form-group">
                  <label>Jumlah Dibayar (Rp)</label>
                  <button-edit-input
                    v-model="data.paid_amount"
                    :rounded="true"
                    :bordered="true"
                  />
                </div>
                <div
                  class="form-group"
                  v-bind:class="{ none: data.status == 3 }"
                >
                  <input type="checkbox" v-model="data.intransit" />&nbsp;
                  <label>Intransit</label>
                </div>
              </c-col>
              <c-col col="6">
                <div class="form-group">
                  <label>Faktur Pembelian</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="data.inv_po"
                  />
                </div>
                <div class="form-group">
                  <label>Tanggal Jatuh Tempo</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="cil-calendar"></i>
                      </span>
                    </div>
                    <datetime
                      type="date"
                      class="date-control-calendar"
                      v-model="data.due_date"
                    />
                  </div>
                </div>
              </c-col>
              <c-col col="6" v-if="data.status == 1 && this.data.intransit">
                <div class="form-group">
                  <label>Estimasi Tanggal Pengiriman</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="cil-calendar"></i>
                      </span>
                    </div>
                    <datetime
                      type="date"
                      class="date-control-calendar"
                      v-model="data.etd"
                      v-bind:class="{ 'has-error': errors.etd }"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label>Rute Pengiriman</label>
                  <div class="input-group">
                    <select-x
                      url="/api/v1/delivery-route"
                      :size="10"
                      v-bind:class="{ 'has-error': errors.delivery_route_id }"
                      v-model="deliveryRoute"
                      @input="changeRoute"
                    />
                  </div>
                </div>
              </c-col>
              <c-col col="6" v-if="data.status == 1 && this.data.intransit">
                <div class="form-group">
                  <label>Estimasi Tanggal Kedatangan</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="cil-calendar"></i>
                      </span>
                    </div>
                    <datetime
                      type="date"
                      class="date-control-calendar"
                      v-model="data.eta"
                      v-bind:class="{ 'has-error': errors.eta }"
                    />
                  </div>
                </div>
              </c-col>
            </c-row>
            <div v-if="data.status == 3">
              <h5>Intransit</h5>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Estimasi Tanggal Dikirim</th>
                    <th>Estimasi Tanggal Diterima</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ data.etd | dateFormat }}</td>
                    <td>{{ data.eta | dateFormat }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <span style="font-size: 11px; color: red"
              >Double click angka untuk melakukan edit</span
            >
            <br />
            <span>Note:</span>
            <ul>
              <li>
                Jika jumlah bayar kurang dari total maka akan masuk ke daftar
                hutang
              </li>
              <li>Isi tanggal jatuh tempo jika kurang bayar</li>
              <li>Tambahkan no faktur dari supplier</li>
            </ul>
          </div>
          <!-- {{ data }} -->
        </c-card-body>
        <c-card-footer v-if="data.status != 2">
          <button
            class="btn btn-outline-success"
            @click="doApprove"
            v-if="!data.intransit"
          >
            <i class="cil-check"></i> Approve
          </button>
          <button
            class="btn btn-outline-success"
            @click="doApprove"
            v-if="data.intransit"
          >
            <i class="cil-check"></i> Intransit
          </button>
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import ButtonEditInput from "../../components/ButtonEditInput2";
import IButton from "../../components/IButton.vue";
import SelectX from "../../components/SelectX";
import { HTTPAUTH } from "../../lib/httplib";
import { showErrorMessage, successMessage } from "../../lib/helpers";
import Loader from "../../components/Loader.vue";
export default {
  components: {
    ButtonEditInput,
    SelectX,
    IButton,
    Loader,
  },
  data () {
    return {
      data: {},
      errors: {},
      deliveryRoute: null,
      preview: false,
      loading: true,
    };
  },
  created () {
    const params = this.$route.params;
    const query = this.$route.query;
    if (params.id) {
      this.get(params.id);
    }
    if (query && query.preview == "true") {
      this.preview = query.preview == "true";
    }
  },
  methods: {
    get (id) {
      this.loading = true;
      HTTPAUTH.get("/api/v1/po/" + id + "/detail")
        .then((res) => {
          this.data = res.data.data;
          this.data.due_date = new Date().toISOString();
          this.calculateTotal();
          if (this.data.status == 3) {
            this.data.intransit = true;
          }
          this.loading = false;
        })
        .catch((eres) => {
          this.loading = false;
          showErrorMessage(eres);
        });
    },
    calculateSub (d) {
      console.log("calculate sub");
      d.sub_total = d.qty_real * d.hpp;
      this.calculateTotal();
    },
    calculateTotal () {
      const details = this.data.purchase_details;
      this.data.total = 0;
      console.log("calculate total");
      for (var i in details) {
        const subTotal = details[i].sub_total;
        this.data.total += subTotal;
      }
    },
    goBack () {
      this.$router.push({ path: "/po/process" });
    },
    changeRoute (v) {
      console.log(v);
      if (v && v.id) {
        this.data.delivery_route_id = v.id;
      }
    },
    doApprove () {
      const data = this.data;
      this.loading = true;
      var url = `/api/v1/po/${data.id}`;
      if (this.data.intransit) {
        const c = confirm('Pengiriman sudah tiba ?')
        if (!c) {
          this.loading = false;
          return;
        }
        url += "/approve-intransit";
      } else {
        url += "/approve";
      }
      HTTPAUTH.put(url, data)
        .then(() => {
          this.loading = false;
          successMessage("berhasil melakukan approve");
        })
        .catch((eres) => {
          this.loading = false;
          this.errors = showErrorMessage(eres);
        });
    },
    doPrint (id) {
      let routeData = this.$router.resolve({ path: `/print/po/${id}` });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>